import React from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux';
import SelectYourXDropdown from './selectYourXDropdown';
import { selectYourXDropdownToggle } from '../actions/selectYourXDropdownsActions';
import { appEnv } from '../constants/appEnv';

class SelectYourX extends React.Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }
    isDisabled() {
        return this.props.selectYourXIndex < this.props.selectYourXDropdownIndex
    }
    onClick(dropdownIndex) {
        this.props.selectYourXDropdownToggle(dropdownIndex);
    }
    render() {
        let imgBase = appEnv.baseImgUrl;
        let displayIndex = this.props.selectYourXDropdownIndex + 1;
        let btnImg = "", btnClass = "", btnChevron = "";
        let btnText = this.props.buttonText;
        let activeDropdown = this.props.selectYourXDropdowns[this.props.selectYourXDropdownIndex].isSelectionOpen;
        let rotationalDirection = activeDropdown ? "-up.png" : "-down.png";
        if (this.props.selectYourXIndex == this.props.selectYourXDropdownIndex) {
            btnClass = "current-selection btn";
            btnImg = imgBase + "/step" + displayIndex + "-active.png";
            btnChevron = imgBase + "/chevron-white" + rotationalDirection;
        }
        else if (this.props.selectYourXIndex > this.props.selectYourXDropdownIndex) {
            btnClass = "selected btn";
            btnImg = imgBase + "/blue-checkmark.png";
            btnChevron = imgBase + "/chevron-brightblue" + rotationalDirection;
        }
        else {
            btnClass = "to-be-selected btn";
            btnImg = imgBase + "/step" + displayIndex + "-disabled.png";
            btnChevron = imgBase + "/chevron-brightblue" + rotationalDirection;
        }
        if (this.props.selectedValue != null) {
            btnText = decodeURIComponent(this.props.selectedValue);
        }
        return (
            <div className='select-your-x'>
                <button disabled={this.isDisabled()} className={btnClass}
                    type="button" onClick={() => this.onClick(this.props.selectYourXDropdownIndex)}>
                    <img src={btnImg} alt={btnText} className="vertical-align-middle" alt={this.props.selectYourXDropdownIndex + 1 + this.props.filterPlaceholderText} />
                    <span className="selectText vertical-align-middle">{btnText}</span>
                    <img src={btnChevron}
                        className={"chevron vertical-align-middle"}
                        alt={"open" + this.props.filterPlaceholderText}
                    />
                </button>
                {activeDropdown ?
                    <SelectYourXDropdown
                        arrayForSelection={this.props.arrayForSelection}
                        currentIndex={this.props.selectYourXDropdownIndex}
                        callBack={this.props.callBack}
                        routePrefix={this.props.routePrefix}
                        urlPrefix={this.props.urlPrefix}
                        urlSuffix={this.props.urlSuffix}
                        queryString={this.props.queryString}
                        filterPlaceholderText={this.props.filterPlaceholderText} />
                    :
                    null
                }
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        selectYourXDropdowns: state.selectYourXDropdowns,
        selectYourXIndex: state.selectYourXIndex
    };
}
function mapDispatchToProps(dispatch) {
    return {
        selectYourXDropdownToggle: (e) => dispatch(selectYourXDropdownToggle(e))
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectYourX);